/** Phones a sandbox account may message: its first five plain-phone contacts. */
export const SANDBOX_MAX_MEMBERS = 5;

export type SandboxTenantLike = {
  phoneNumberId?: string | null;
  /** Join code for the shared sandbox number, minted at sign-up while the sandbox is on. */
  sandboxCode?: string | null;
};

/** On the shared sandbox number: has a join code and no number of its own. */
export const isSandboxTenant = (
  business: SandboxTenantLike | null | undefined,
) => !business?.phoneNumberId && !!business?.sandboxCode;

export type BusinessSetupLike = SandboxTenantLike & {
  businessAccountId?: string | null;
  fbAppId?: string | null;
  sipConfig?: { inboundTrunkId?: string; outboundTrunkId?: string } | null;
  /** An active RCS agent key exists for this business. */
  hasRcs?: boolean;
};

/** Can message someone: its own WhatsApp number, the sandbox, a SIP trunk or an RCS agent. */
export const isBusinessSetUp = (
  business: BusinessSetupLike | null | undefined,
) =>
  !!(
    business?.phoneNumberId &&
    business?.businessAccountId &&
    business?.fbAppId
  ) ||
  isSandboxTenant(business) ||
  !!(
    business?.sipConfig?.inboundTrunkId || business?.sipConfig?.outboundTrunkId
  ) ||
  !!business?.hasRcs;
